<template>
  <ymap-marker
    :coords="coords"
    :marker-id="`filial-${filial.id}`"
    :hint-content="filial.name"
    :balloon-template="balloonTemplate"
    :icon="icon"
  />
</template>

<script>
  import { ymapMarker } from 'vue-yandex-maps'

  const PIN_COLOR = '#ff9100'

  const PIN_SVG = `
<svg xmlns="http://www.w3.org/2000/svg" width="32" height="42" viewBox="0 0 46 60">
  <path d="M23 2C11.4 2 2 11.4 2 23c0 15.8 21 35 21 35s21-19.2 21-35C44 11.4 34.6 2 23 2Z"
        fill="${PIN_COLOR}" stroke="#ffffff" stroke-width="3"/>
  <path d="M14 22.5 23 15l9 7.5" stroke="#ffffff" stroke-width="2.4"
        stroke-linecap="round" stroke-linejoin="round" fill="none"/>
  <path d="M16.5 21.5V29a1 1 0 0 0 1 1h3.5v-5h4v5h3.5a1 1 0 0 0 1-1v-7.5"
        stroke="#ffffff" stroke-width="2.4" stroke-linecap="round"
        stroke-linejoin="round" fill="none"/>
</svg>`

  export default {
    name: 'FilialMarker',
    components: {
      ymapMarker,
    },
    props: {
      filial: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      coords () {
        return [parseFloat(this.filial.lat), parseFloat(this.filial.let)]
      },
      balloonTemplate () {
        return `<p>${this.filial.name || 'Филиал'}</p>`
      },
      icon () {
        return {
          layout: 'default#image',
          imageHref:
            'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(PIN_SVG),
          imageSize: [32, 42],
          imageOffset: [-16, -41],
        }
      },
    },
  }
</script>
